import React, { useState } from 'react';
import { withRouter } from 'react-router';
import { Translation, getI18n } from 'react-i18next';
import { Button, Col, Row, Typography } from 'antd';
import { FaRegTrashAlt } from 'react-icons/fa';
import ConfirmationModal from '../../../elements/components/ConfirmationModal';

const { Text } = Typography;

const confirmTexts = {
  title: getI18n().t('learning_admin_module_serie_action_delete_title'),
  description: null,
  leaveText: getI18n().t('learning_admin_module_series_action_delete_leave'),
  saveText: getI18n().t('learning_admin_module_serie_action_delete_save'),
};

const LearningAdminModuleSeriesTableListHeader = ({
  selectedRowKeys,
  handleDeletes,
  ...props
}) => {
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);

  const handleConfirmLeave = () => {
    setConfirmationModalOpen(false);
  };

  const handleConfirmDelete = () => {
    setConfirmationModalOpen(false);
    handleDeletes();
  };

  return (
    <Translation>
      {(t) => (
        <>
          <div className='module-serie-list-table-header'>
            {selectedRowKeys.length > 0 && (
              <Row
                align='middle'
                gutter={16}
                className='module-serie-list-table-header-row'
              >
                <Col>
                  <Text>
                    {t('learning_admin_module_serie_list_table_show_selected', {
                      selected: selectedRowKeys.length,
                    })}
                  </Text>
                </Col>
                <Col>
                  <Button
                    danger
                    size='large'
                    onClick={() => setConfirmationModalOpen(true)}
                  >
                    <span className='anticon'>
                      <FaRegTrashAlt />
                    </span>
                    {t('learning_admin_list_table_delete_module_series')}
                  </Button>
                </Col>
              </Row>
            )}
          </div>
          <ConfirmationModal
            texts={confirmTexts}
            openConfirmationModal={confirmationModalOpen}
            onLeaveConfirmation={handleConfirmDelete}
            onSaveConfirmation={handleConfirmLeave}
            onCancel={handleConfirmLeave}
            setConfirmationModalOpen={setConfirmationModalOpen}
          />
        </>
      )}
    </Translation>
  );
};

export default withRouter(LearningAdminModuleSeriesTableListHeader);
